export default function LoaderBar({ bars, color, className }) {
    let classNames = className ? className : '';
    let barColor = color ? color : 'beige-200';
    return(
        <>
            {bars === 1 ?
                <div className={`w-full h-[15px] rounded-xxs animate-pulse bg-${barColor} ${classNames}`}></div>
            : null}
            {bars === 2 ?
              <>
                  <div className={`w-full h-[15px] rounded-xxs animate-pulse bg-${barColor} ${classNames}`}></div>
                  <div className={`w-3/5 h-[15px] mt-3 rounded-xxs animate-pulse bg-${barColor} ${classNames}`}></div>
              </>
                : null}
        </>
    )
}